import { Modal } from 'antd';
import type { ModalFuncProps } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { createElement } from 'react';

type ConfirmOptions = Omit<ModalFuncProps, 'icon' | 'okButtonProps' | 'cancelButtonProps'> & {
  danger?: boolean;
};

export function ipcConfirm(options: ConfirmOptions) {
  const {
    className,
    rootClassName,
    okText = '确认',
    cancelText = '取消',
    ...rest
  } = options;

  return Modal.confirm({
    ...rest,
    maskClosable: rest.maskClosable ?? false,
    rootClassName: ['ipc-modal-root', rootClassName].filter(Boolean).join(' '),
    className: ['ipc-confirm', className].filter(Boolean).join(' '),
    icon: createElement(ExclamationCircleFilled, {
      className: 'ipc-confirm__icon',
      'aria-hidden': true,
    }),
    okText,
    cancelText,
    okButtonProps: {
      className: 'ipc-btn ipc-btn--destructive',
      type: 'default',
      danger: true,
    },
    cancelButtonProps: {
      className: 'ipc-btn ipc-btn--secondary',
      type: 'default',
    },
    centered: true,
  });
}
